import React from "react";
import { createRoot } from "react-dom/client";

import ProjectsShow from "../components/projects/projects_show/projects_show";

document.addEventListener("turbo:load", () => {
  const mountPoint = document.getElementById("projects-show-mount-point");

  if (mountPoint) {
    const root = createRoot(mountPoint);
    const { projectId } = mountPoint.dataset;
    root.render(<ProjectsShow projectId={projectId} />);
  }
});
